import React from 'react';
import { Button, ButtonProps, StackProps, useColorModeValue, VStack } from '@chakra-ui/react';

import { ArcButton } from './ArcButton';

const COLOR_ARC = '#3DCD58';
const COLOR_BUTTON_FILL = '#505559';

type ContinueAndSkipButtonProps = Omit<StackProps, 'children'> & {
  continueButtonProps?: Omit<ButtonProps, 'children' | 'onClick' | 'isLoading'>;
  continueLabel?: React.ReactNode;
  continueTestId?: string;
  isLoading?: boolean;
  onContinue?: () => void;
  onSkip?: () => void;
  skipButtonProps?: Omit<ButtonProps, 'children' | 'onClick' | 'isLoading'>;
  showContinue?: boolean;
  showSkip?: boolean;
  skipLabel?: React.ReactNode;
  skipTestId?: string;
};

export function ContinueAndSkipButton({
  continueButtonProps,
  continueLabel,
  continueTestId,
  isLoading,
  onContinue,
  onSkip,
  skipButtonProps,
  showContinue = true,
  showSkip = false,
  skipLabel,
  skipTestId,
  ...rest
}: ContinueAndSkipButtonProps) {
  const skipButtonColor = useColorModeValue('schneiderSkyBlue.600', 'schneiderSkyBlue.200');

  return (
    <VStack display="flex" alignItems="center" py={2} flexShrink={0} spacing={0} {...rest}>
      {showContinue && (
        <ArcButton
          arcColor={COLOR_ARC}
          w="100%"
          my={4}
          background={COLOR_BUTTON_FILL}
          _hover={{ background: COLOR_BUTTON_FILL }}
          color="white"
          borderColor={COLOR_BUTTON_FILL}
          sx={{ '> div': { background: `${COLOR_BUTTON_FILL} !important` } }}
          {...continueButtonProps}
          onClick={onContinue}
          data-testid={continueTestId}
          isLoading={isLoading}
        >
          {continueLabel}
        </ArcButton>
      )}

      {showSkip && (
        <Button
          variant="link"
          minWidth="fit-content"
          w="fit-content"
          fontWeight={400}
          fontSize={15}
          mb={2}
          mt={showContinue ? 0 : 4}
          color={skipButtonColor}
          {...skipButtonProps}
          onClick={onSkip}
          data-testid={skipTestId}
          isLoading={isLoading}
        >
          {skipLabel}
        </Button>
      )}
    </VStack>
  );
}
